import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Upload } from "antd";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { UPLOAD_MEDIA } from "../../reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import SignatureCanvas from 'react-signature-canvas'

const UploadSignatureModal: FC<{ isBio?: boolean, onClose?: () => void }> = ({ isBio, onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [fileList, setFileList] = useState<any>([]);
  const [location, setLocation] = useState<any>();
  const { selectedItem } = useSelector(
    (state: RootState) => state.search
  );
  const { userBds } = useSelector((state: RootState) => state.auth);
  const [saving, setSaving] = useState<boolean>(false);
  const { fileToSend } = useSelector((state: RootState) => state.message);
  const sentCount = useRef(0);
  const canvasRef = useRef<any>();


  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {type:mimeString});
}

  const dispatch = useDispatch();
  const handleOk = () => {
    const dataUri = canvasRef.current.getTrimmedCanvas().toDataURL('image/png');
    const fileBlob = dataURItoBlob(dataUri);
    const dateTime = new Date().getTime();
    let form = new FormData();
    form.append("file", fileBlob, `signature-${dateTime}.png`);
    form.append("info", JSON.stringify({pageId: selectedItem.pageId, userId: localStorage.getItem('RID'), location: location ? {coordinates: location, clbs: {
      tags: ['type:media', `org:${selectedItem?.persistent?.static?.iotAsset?.config?.configUserCudbServiceId}`, `signature-${dateTime}.png`]
    }}: undefined}));
    dispatch(UPLOAD_MEDIA({form, isBio: false}));
    setSaving(true);
  };

  useEffect(() => {
    getCurrentLocation()
  }, []);

  useEffect(() => {
    if (fileToSend) {
      sentCount.current += 1;
      if(sentCount.current === fileList.length){
        setIsModalVisible(false);
        onClose && onClose();
      }
    }
  }, [fileToSend]);

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          setLocation({
            lat: position?.coords?.latitude,
            long: position?.coords?.longitude,
          });
        });
      } else {
        reject("Geolocation is not supported by this browser.");
      }
    });
  };

  useEffect(() => {
    getCurrentLocation()
  }, []);

  //   const fileParser = (file) => {
  //     return new Promise(async (s, r) => {
  //       const location = await getCurrentLocation();
  //       const data = {
  //         filename: file.name,
  //         size: file.size,
  //         mimetype: file.type,
  //         location: location,
  //       };
  //       const reader = new FileReader();
  //       reader.readAsArrayBuffer(file);
  //       reader.onload = (e) => {
  //         const content = e.target.result;
  //         data.content = content;
  //         s(data);
  //       };
  //     });
  //   };

  return (
    <Modal
      title="Add a signature"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <SignatureCanvas ref={(ref) => { canvasRef.current = ref }} penColor='black' backgroundColor='white'
    canvasProps={{width: 420, height: 200, className: 'sigCanvas'}} />

      <Row className="action-grp mt-4">
        <Col span={14} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
            loading={saving}
          >
            Upload
          </Button>
        </Col>
        <Col span={10} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default UploadSignatureModal;
